// src/ui/navigation.js
// src/ui/navigation.js
// Aggregator for Router and SettingsManager modules

window.ui = {
    // Ekranları Göster/Gizle
    // Ekranları Göster/Gizle
    showScreen: function (screenId, ...args) {
        if (window.Router) {
            window.Router.showScreen(screenId, ...args);
        } else {
            console.error("Router module not loaded!");
        }
    },

    // Ayarları Başlat
    initSettings: function () {
        if (window.SettingsManager) {
            window.SettingsManager.init();
        } else {
            console.error("SettingsManager module not loaded!");
        }
    },

    // Geri Git
    goBack: function () {
        if (window.Router) {
            window.Router.goBack();
        } else {
            console.error("Router module not loaded!");
        }
    },

    // Tarayıcı Geri Butonunu Yönet (History API)
    initHistory: function () {
        if (window.Router) {
            window.Router.init();

            // [NEW] Global ESC Key Handler - Unified priority system
            document.addEventListener('keydown', (e) => {
                if (e.key === 'Escape') {
                    if (window.audio && window.audio.playSound) window.audio.playSound('back');
                    // 1. Priority: Custom Confirm Modals
                    const confirmModal = document.getElementById('custom-confirm-modal');
                    if (confirmModal) {
                        confirmModal.remove();
                        return;
                    }

                    // 2. Priority: Settings Modal
                    const settingsModal = document.getElementById('settings-modal');
                    if (settingsModal && !settingsModal.classList.contains('hidden')) {
                        settingsModal.classList.add('hidden');
                        if (window.AccessibilityManager) window.AccessibilityManager.releaseFocus();
                        return;
                    }

                    // 3. Priority: Radio Modal
                    const radioModal = document.getElementById('radio-modal');
                    if (radioModal && !radioModal.classList.contains('hidden')) {
                        radioModal.classList.add('hidden');
                        if (window.AccessibilityManager) window.AccessibilityManager.releaseFocus();
                        return;
                    }

                    // 4. Priority: Accessibility Modal
                    const accModal = document.getElementById('accessibility-modal');
                    if (accModal && !accModal.classList.contains('hidden')) {
                        accModal.classList.add('hidden');
                        return;
                    }

                    // 4. Priority: Profile Modal
                    const profileModal = document.getElementById('profile-modal');
                    if (profileModal && !profileModal.classList.contains('hidden')) {
                        profileModal.classList.add('hidden');
                        return;
                    }

                    // 5. Priority: Sidebar
                    const sidebar = document.getElementById('app-sidebar');
                    if (sidebar && sidebar.classList.contains('active')) {
                        if (window.SidebarManager) window.SidebarManager.toggle(false);
                        return;
                    }

                    // 6. Priority: Category Modal (Academic Categories)
                    const categoryModal = document.getElementById('academic-categories-container');
                    if (categoryModal && !categoryModal.classList.contains('hidden')) {
                        categoryModal.classList.add('hidden');
                        return;
                    }

                    // 7. Priority: Router Back (only if not on main screen)
                    const activeScreen = document.querySelector('.screen.active');
                    if (activeScreen && activeScreen.id !== 'category-screen') {
                        window.ui.goBack();
                    }
                }
            });

        } else {
            console.error("Router module not loaded!");
        }
    }
};
